import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/shared/reducers/user-management';
import { IGoodGovernanace } from 'app/shared/model/good-governanace.model';
import { getEntity, updateEntity, createEntity, reset } from './good-governanace.reducer';

export const GoodGovernanaceUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const goodGovernanaceEntity = useAppSelector(state => state.goodGovernanace.entity);
  const loading = useAppSelector(state => state.goodGovernanace.loading);
  const updating = useAppSelector(state => state.goodGovernanace.updating);
  const updateSuccess = useAppSelector(state => state.goodGovernanace.updateSuccess);

  const handleClose = () => {
    navigate('/good-governanace' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.modifiedDate = convertDateTimeToServer(values.modifiedDate);

    const entity = {
      ...goodGovernanaceEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.user.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
          modifiedDate: displayDefaultDateTime(),
        }
      : {
          ...goodGovernanaceEntity,
          createdDate: convertDateTimeFromServer(goodGovernanaceEntity.createdDate),
          modifiedDate: convertDateTimeFromServer(goodGovernanaceEntity.modifiedDate),
          user: goodGovernanaceEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.goodGovernanace.home.createOrEditLabel" data-cy="GoodGovernanaceCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.goodGovernanace.home.createOrEditLabel">Create or edit a GoodGovernanace</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="good-governanace-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.goodGovernanace.imageName')}
                id="good-governanace-imageName"
                name="imageName"
                data-cy="imageName"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.goodGovernanace.topics')}
                id="good-governanace-topics"
                name="topics"
                data-cy="topics"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.goodGovernanace.approved')}
                id="good-governanace-approved"
                name="approved"
                data-cy="approved"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fivePlusApp.goodGovernanace.description')}
                id="good-governanace-description"
                name="description"
                data-cy="description"
                type="textarea"
              />
              <ValidatedField
                label={translate('fivePlusApp.goodGovernanace.link')}
                id="good-governanace-link"
                name="link"
                data-cy="link"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.goodGovernanace.createdDate')}
                id="good-governanace-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fivePlusApp.goodGovernanace.modifiedDate')}
                id="good-governanace-modifiedDate"
                name="modifiedDate"
                data-cy="modifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="good-governanace-user"
                name="user"
                data-cy="user"
                label={translate('fivePlusApp.goodGovernanace.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/good-governanace" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default GoodGovernanaceUpdate;
